module.exports = __webpack_public_path__ + "img/vodafone.ea029a22.svg";